<template>
  <div>
    <div class="air__utils__heading">
      <h5>Dashboard</h5>
    </div>
    <!-- {{ $t('welcome') }} -->

    <div class="row">
      <div class="col-md-12 d-none d-md-block mb-4">
<!--        <quick-links /> Todo: Temporary commented for role base access feature-->
      </div>
    </div>

    <div class="row" v-if="!loading && data">
      <div class="col-md-4">
        <div class="card">
          <div class="card-body neo-dash-card-height-190">
            <NeoCurrentSessionWidget
              :session="data.current_session"
              :totalSessions="data.session_count"
            />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card">
          <div class="card-body neo-dash-card-height-190">
            <NeoClassCard
              :classCount="data.class_count"
              :sectionCount="data.section_count"
              :classSectionCount="data.class_section_count"
            />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card">
          <div class="card-body neo-dash-card-height-190">
            <NeoStaffCard
              :totalStaff="data.total_staff"
            />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card">
          <div class="card-body neo-dash-card-height-190">
            <ActiveEnrollmentCard
              :students="data.total_students"
              :enrolled="data.total_enroll"
              :notEnrolled="data.total_non_enroll"
              :activeCount="data.total_active_count"
            />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card">
          <div class="card-body neo-dash-card-height-190">
            <InactiveStudentCard
              :inactiveCount="data.total_inactive_count"
              :inactiveTcCount="data.total_inactive_tc_count"
              :inactiveAbscondCount="data.total_inactive_abscond_count"
              :inactiveOtherCount="data.total_inactive_other_count"
            />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card">
          <div class="card-body neo-dash-card-height-190">
            <p class="card-title font-weight-bold">Working Days</p>
            <NeoWorkingDayWidget
              :running="data.current_working_days"
              :expected="data.expected_working_days"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import QuickLinks from '@/components/dashboard/Quicklinks/index'
import NeoClassCard from '@/components/dashboard/ClassCard/index'
import NeoStaffCard from '@/components/dashboard/StaffCard/index'
import ActiveEnrollmentCard from '@/components/dashboard/Enrollment/ActiveEnrollmentCard'
import InactiveStudentCard from '@/components/dashboard/Enrollment/InactiveStudentCard'
import NeoWorkingDayWidget from '@/components/dashboard/Workingday/index'
import NeoCurrentSessionWidget from '@/components/dashboard/CurrentSession/index'

export default {
  components: {
    // QuickLinks,
    NeoClassCard,
    NeoStaffCard,
    ActiveEnrollmentCard,
    InactiveStudentCard,
    NeoWorkingDayWidget,
    NeoCurrentSessionWidget,
  },
  mounted() {
    this.loading = true
    this.$http.get('/api/reports/dashboard')
      .then(({ data }) => {
        this.data = data.data
        this.loading = false
      })
      .catch(error => {
        console.log(error)
        this.loading = false
      })
  },
  data() {
    return {
      loading: false,
      data: null,
    }
  },
}
</script>
